import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user\"><path d=\"M690.06489 543.371368a300.933119 300.933119 0 1 0-356.71834 0 469.36923 469.36923 0 0 0-290.356104 433.430127 47.027908 47.027908 0 1 0 94.112681 0 374.744757 374.744757 0 0 1 749.489514 0 47.027908 47.027908 0 1 0 94.055816 0 469.710424 469.710424 0 0 0-290.583567-433.430127z m-385.321771-242.247749a206.991034 206.991034 0 1 1 413.982068 0 206.991034 206.991034 0 0 1-413.982068 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol